/** Gold avatar initials — handoff / reference standard. */
export const AVATAR_GOLD = "#C4790A";

export function displayInitials(name = "", max = 2) {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, max).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).slice(0, max).toUpperCase();
}

export function resolveAvatarSrc(src) {
  const value = src?.trim?.() ?? src;
  return value ? String(value).trim() : "";
}

export function hasAvatarSrc(src) {
  return Boolean(resolveAvatarSrc(src));
}
